import { createContext, useContext } from 'react';
const AppContext = /*#__PURE__*/createContext('app');
export const AppContextProvider = AppContext.Provider;
export function useAppContext() {
  return useContext(AppContext);
}